import api from '../lib/axios';
export async function searchPharmacies(query) {
    const { data } = await api.get('/api/admin/pharmacies/search', { params: { q: query } });
    return data.data;
}
export async function getPharmacyDuties(params = {}) {
    const { data } = await api.get('/api/admin/pharmacy-duties', {
        params: { upcoming: params.upcoming ? 1 : 0, month: params.month },
    });
    return data.data;
}
export async function createPharmacyDuty(body) {
    await api.post('/api/admin/pharmacy-duties', body);
}
export async function deletePharmacyDuty(id) {
    await api.delete(`/api/admin/pharmacy-duties/${id}`);
}
